// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3kRR3","contato":"Footer_contato__20JcM"};